module.exports = __webpack_public_path__ + "static/img/monitor_content_bg1.3ff8705.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/programme/monitor_content_bg1.png
// module id = ycH3
// module chunks = 1